
export const MPTAccessKeyPanel = props => {
  const imgSrc = props.data.imgSrc
  const alt = props.data.alt

  return (
    <div className="accessKeyContainer">
      <img src={imgSrc} alt={alt} id="accessKeyPanelImg" className="noContextMenu" />
    </div>
  )
  
}